// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__NhSIQ","choiceBoxes":"toolbarselects_choiceBoxes__iA_vG","simpleField":"toolbarselects_simpleField__4dAf6"};